<template>
  <div class="">
      <p>
        The pricing on this item has expired.
      </p>
      <p>
        <ButtonWithLoading
          @click.native="getPriceClicked"
          text="Request Price Update"
          loadingText="Sending"
          successText="Sent Request"
          failureText="Couldn't Send Request"
          :state="addState"
          class="btn-block my-2"
        >
        </ButtonWithLoading>
      </p>
  </div>
</template>

<script>

import ButtonWithLoading from "@/components/buttonWithLoading";

import {postPriceRequest} from "@/network/userRequests";

export default {
  name: 'ProductGetPrice',
  components: {
      ButtonWithLoading

  },
  props:["product"],
  data(){
      return{
        addState: null
      }
  },
  methods:{
      getPriceClicked(){
          this.addState = "loading"
          let info = {product_id : this.product.id}
          postPriceRequest(info, 
          () =>{ //success
            this.addState = "success"
            setTimeout(() => {
               this.addState = null 
            }, 3000);
          },
          () =>{ //error
            this.addState = "error"
            setTimeout(() => {
                this.addState = null;
            }, 1000);
          })
      }
  }
}
</script>

<style lang="scss" scoped>

</style>
